import GenericBody from "../Componentes/GenericBody";
import NavBar from "../Componentes/NavBar";
import { useModal } from "../contexts/ModalContext";
import GestaoAcessosV2 from "../Modulos/GestaoAcessosV2/GestaoAcessosV2";
import SidebarGestaoAcessosV2 from "../Modulos/GestaoAcessosV2/SidebarGestaoAcessosV2";

const SIDEBAR_ID = "sidebarGestaoAcessosV2";

const GestaoAcessosV2Route = () => {
    const { openModal, isModalOpen } = useModal();

    return (
        <>
            <NavBar
                title="GESTÃO DE ACESSOS"
                navTo="/modules"
                setSideBar={() => openModal(SIDEBAR_ID)}
            />
            <GenericBody>
                <GestaoAcessosV2 />
            </GenericBody>
            {isModalOpen(SIDEBAR_ID) && <SidebarGestaoAcessosV2 />}
        </>
    );
};

export default GestaoAcessosV2Route;
